import localforage from 'localforage';
import { v4 as uuidv4 } from 'uuid';

// Offline outbox for sync-able operations.
// MVP: queue "sale" payloads and flush when online.

const store = localforage.createInstance({
  name: 'pos-retail',
  storeName: 'outbox',
});

export async function enqueue(kind, payload) {
  const id = uuidv4();
  const item = {
    id,
    kind,
    payload,
    status: 'queued',
    createdAt: new Date().toISOString(),
    attempts: 0,
    lastError: null,
  };
  await store.setItem(id, item);
  return item;
}

export async function listQueued() {
  const items = [];
  await store.iterate((value) => {
    if (value?.status === 'queued') items.push(value);
  });
  items.sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1));
  return items;
}

export async function markDone(id) {
  const item = await store.getItem(id);
  if (!item) return;
  await store.setItem(id, { ...item, status: 'done', doneAt: new Date().toISOString() });
}

export async function markFailed(id, errorText) {
  const item = await store.getItem(id);
  if (!item) return;
  await store.setItem(id, {
    ...item,
    status: 'queued',
    attempts: (item.attempts || 0) + 1,
    lastError: errorText?.slice?.(0, 500) || String(errorText),
    lastAttemptAt: new Date().toISOString(),
  });
}
